module.exports = __webpack_public_path__ + "img/shouchi.d4107aa0.jpg";